import React from 'react';

function Codeblock(props) {
  return (
    <div className="code-block"><pre><code>{props.children}</code></pre></div>
  );
}

export default Codeblock;